import React from 'react';
import { Form, Button, FormGroup } from 'react-bootstrap';
import InfoComponent from './InfoComponent';

const FormComponent = ({ onSubmit, url, setUrl, keyword, setKeyword }) => {
  const safeUrl = url ?? '';
  const safeKeyword = keyword ?? '';

  const handleSubmit = (event) => {
    event.preventDefault();

    const cleanUrl = safeUrl.trim();
    const cleanKeyword = safeKeyword.trim();

    setUrl(cleanUrl);
    setKeyword(cleanKeyword);

    onSubmit(cleanUrl, cleanKeyword);
  };

  // Vérifier si les champs sont remplis pour activer ou désactiver le bouton
  const isButtonDisabled = !safeUrl.trim() || !safeKeyword.trim();

  return (
    <div>
      <h1 className="mb-2 d-flex align-items-center">
        <i className="bi bi-info-circle-fill small me-2"></i>
        Adresse & Requête clé
        <InfoComponent
          text="Saisissez l'URL complète de la page à analyser et le mot-clé principal pour lequel vous souhaitez optimiser votre référencement. Ces informations permettront d'évaluer la pertinence SEO de votre contenu."
          style={{
            marginLeft: '0.5rem',
            marginTop: '0.5em'
          }}
        />
      </h1>

      <div className="alert alert-secondary mb-2">
        <Form onSubmit={handleSubmit} className="row mb-2 align-items-end">
          <FormGroup className='col-md-12' controlId='formUrl'>

            <div className="form-text">Entrez le lien de la page que vous voulez analyser :</div>
            <Form.Control
              type="text"
              placeholder="Lien de la page"
              value={safeUrl}
              onChange={e => setUrl(e.target.value)}
              className="form-control"
            />
          </FormGroup>
          <FormGroup className='col-md-9' controlId='formKeyword'>
            <div className="form-text">Entrez la requête clé qui caractérise votre page :</div>
            <Form.Control
              type="text"
              placeholder="Keyword"
              value={safeKeyword}
              onChange={e => setKeyword(e.target.value)}
            />
          </FormGroup>
          <div className='col-md-3'>
            <Button type="submit" disabled={isButtonDisabled} className="w-100">
              Analyser
            </Button>
          </div>
        </Form>
      </div>
    </div>
  );
};

export default FormComponent;
